// src/ViewNotifications.jsx
import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  Pagination,
  Stack
} from '@mui/material';
import Navbar from './NavigationTalent';
import api from '../api/api';
import { ENDPOINTS } from '../api/endpoints';
import Footer from '../Footer';

const ViewNotifications = () => {
  const [userId, setUserId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 10;

useEffect(() => {
  const stored = localStorage.getItem('userId');
  if (stored) setUserId(stored);
}, []);

useEffect(() => {
  if (!userId) return;

  const fetchMessages = async () => {
    setLoading(true);
    setError(null);

    try {
      const resp = await api.get(
        ENDPOINTS.getUserResumeMessagesWithCounts(),
        {
          params: {
            userId,
            pageNumber: currentPage,
            pageSize,
          },
        }
      );

      const data = resp.data?.data || {};

      setMessages(data.messages || []);

      const totalCount =
        data.counts?.totalCount ||
        resp.data?.totalCount ||
        0;

      setTotalPages(Math.ceil(totalCount / pageSize));
    } catch (err) {
      console.error(err);
      setError(err.message || "Failed to load notifications");
    } finally {
      setLoading(false);
    }
  };

  fetchMessages();
}, [userId, currentPage]);

  if (loading) return <CircularProgress sx={{ m: 4 }} />;
  if (error) return <Typography color="error">Error: {error}</Typography>;

  return (
    <div>
      <Navbar />
      <Box sx={{ background: '#eeeeee', py: 4 }}>
        <Box
          sx={{
            maxWidth: 1200,
            mx: 'auto',
            background: '#fff',
            borderRadius: 2,
            boxShadow: 1,
            p: 3
          }}
        >
          <Typography variant="h4" gutterBottom>
            View Notifications
          </Typography>

          {messages.length === 0 ? (
            <Typography>No unread resume views found.</Typography>
          ) : (
            <>
              {messages.map((msg) => (
                <Paper key={msg.messageId} sx={{ p: 2, mb: 2 }} elevation={2}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {msg.subject}
                    {msg.status === 'n' && (
                      <Box
                        component="span"
                        sx={{
                          background: 'red',
                          color: 'white',
                          fontSize: '10px',
                          px: 1,
                          ml: 1,
                          borderRadius: '12px',
                          fontWeight: 'bold'
                        }}
                      >
                        NEW
                      </Box>
                    )}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Date: {new Date(msg.date).toLocaleString()}
                  </Typography>
                  <Box
                    sx={{ mt: 1 }}
                    dangerouslySetInnerHTML={{ __html: msg.message }}
                  />
                </Paper>
              ))}

              <Stack spacing={2} alignItems="center" sx={{ mt: 4 }}>
  <Pagination
    count={totalPages}
    page={currentPage}
    onChange={(_, page) => setCurrentPage(page)}
    color="primary"
    siblingCount={2}
    boundaryCount={2}
  />
</Stack>
            </>
          )}
        </Box>
      </Box>
      <Footer/>
    </div>
  );
};

export default ViewNotifications;
